/**
 * Variable-carb counter: plan `default_scaled_carbs` for fresh/unselected items;
 * saved `item.scaled_carbs` only when the item is already selected/preselected.
 */

export function planDefaultScaledCarbs(default_scaled_carbs: unknown): number {
  const n = Number(default_scaled_carbs);
  return Number.isFinite(n) && n > 0 ? Math.round(n) : 50;
}

/** Value shown on the carb stepper. */
export function resolveMenuItemScaledCarbsDisplay(
  item: { scaled_carbs?: number; quantity?: number; is_selected?: boolean },
  default_scaled_carbs: unknown,
): number {
  const fallback = planDefaultScaledCarbs(default_scaled_carbs);
  const selected = Boolean(item.is_selected || Number(item.quantity) > 0);
  if (!selected) {
    return fallback;
  }
  const raw = Number(item.scaled_carbs);
  return Number.isFinite(raw) && raw > 0 ? Math.round(raw) : fallback;
}

/**
 * On first select (qty 0 → 1), always seed plan default_carbs.
 * Preselected rows never hit this path (qty already > 0); they keep API scaled_carbs via display.
 */
export function resolveScaledCarbsOnFirstSelect(
  _existing_scaled_carbs: unknown,
  default_scaled_carbs: unknown,
): number {
  return planDefaultScaledCarbs(default_scaled_carbs);
}
